const SYNODIC = 29.530588853;
const EPOCH = Date.UTC(2000, 0, 6, 18, 14);
const PHASES = [[1.84, "New Moon"], [5.53, "Waxing Crescent"], [9.22, "First Quarter"], [12.91, "Waxing Gibbous"], [16.61, "Full Moon"], [20.3, "Waning Gibbous"], [23.99, "Last Quarter"], [27.68, "Waning Crescent"], [Infinity, "New Moon"]];

export const moonToday = (now = Date.now()) => {
  const age = ((((now - EPOCH) / 86400000) % SYNODIC) + SYNODIC) % SYNODIC;
  const lit = (1 - Math.cos((2 * Math.PI * age) / SYNODIC)) / 2;
  const name = PHASES.find(([limit]) => age < limit)[1];
  const toFull = (SYNODIC / 2 - age + SYNODIC) % SYNODIC;
  return { age, lit, name, toFull: Math.round(toFull) };
};

const R = 10;

const MoonIcon = ({ age, lit }) => {
  const rx = R * Math.abs(1 - 2 * lit);
  const litRight = age > SYNODIC / 2;
  const d = `M0 ${-R} A${R} ${R} 0 0 1 0 ${R} A${rx} ${R} 0 0 ${lit < 0.5 ? 0 : 1} 0 ${-R} Z`;
  return (
    <svg viewBox="-12 -12 24 24" className="w-5 h-5 shrink-0" aria-hidden="true">
      <circle r={R} fill="#1E1714" stroke="#D9B47A" strokeOpacity="0.35" strokeWidth="0.6" />
      <path d={d} fill="#F2E8DF" transform={litRight ? undefined : "scale(-1 1)"} />
    </svg>
  );
};

export default function MoonPhase() {
  const m = moonToday();
  const note = m.name === "Full Moon" ? `${Math.round(m.lit * 100)}% lit` : m.toFull <= 1 ? "Full moon tomorrow" : `Full moon in ${m.toFull} days`;
  return (
    <span data-testid="footer-moon-phase" title="Tonight’s moon, as seen from the southern hemisphere" className="inline-flex items-center gap-3">
      <MoonIcon age={m.age} lit={m.lit} />
      <span><span data-testid="footer-moon-name" className="text-[#F2E8DF]">{m.name}</span> · {note}</span>
    </span>
  );
}
